export const blockIconsPrivacyandsecurityShieldLockNew = (
	<span className='material-symbols-outlined'>shield_lock</span>
);
